module.exports = new Promise(resolve => {
    import(/* webpackIgnore: true */ 'https://app-global-search.app-dev.connectcdk.com/assets/remoteEntry.js?t=' + Date.now()).then(remote => {
        resolve({
            get: (r) => remote.get(r),
            init: (s) => { try { return remote.init(s) } catch (e) {} }
        })
    })
});